import { ReactNode, FC } from 'react';
import { Alert } from 'antd';

export interface AlertErrorBoundaryProps {
  message: ReactNode;
  description: ReactNode;
  children?: ReactNode;
}

const ProAlertErrorBoundary: FC<AlertErrorBoundaryProps> = (props) => {
  const { children, ...resProps } = props;
  return (
    <Alert.ErrorBoundary { ...resProps }>{children}</Alert.ErrorBoundary>
  );
}

export default ProAlertErrorBoundary;